// HTMX Configuration
document.addEventListener('DOMContentLoaded', function() {
  // Add CSRF token to all HTMX requests
  document.body.addEventListener('htmx:configRequest', function(event) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    event.detail.headers['X-CSRF-Token'] = csrfToken;
  });

  // Handle confirmation dialogs
  document.body.addEventListener('htmx:confirm', function(event) {
    const confirmation = confirm(event.detail.message);
    if (!confirmation) {
      event.preventDefault();
    }
  });

  // Log HTMX events for debugging
  document.body.addEventListener('htmx:beforeRequest', function(event) {
    console.log('HTMX request:', event.detail);
  });

  document.body.addEventListener('htmx:responseError', function(event) {
    console.error('HTMX response error:', event.detail);
  });
});
